<template>
     <!-- Experience Modal -->
  <v-dialog v-model="modalDialog" max-width="525px">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Skills Required Informations</h5>
        <button type="button" class="close" @click="method(true)">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form @submit.prevent="postApplicationSkill">
          <div>
            <div class="card">
              <div class="card-body">
                <h3 class="card-title">
                  Grade yourself on this required skills
                </h3>
                <div class="row">
                  <div class="col-md-12">
                    <div
                      class="alert alert-danger alert-dismissible fade show"
                      role="alert"
                      v-if="error"
                    >
                      <strong>Error!</strong> {{ error }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div
                      class="alert alert-success alert-dismissible fade show"
                      role="alert"
                      v-if="message"
                    >
                      <strong>Success!</strong> {{ message }}
                      <button
                        type="button"
                        class="close"
                        data-dismiss="alert"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="!complete">
                  <div class="col-md-7">
                      <span>{{item.skill.name}}</span>
                  </div>
                  <div class="col-md-5">
                        <select class="form-control" v-model="gradeId" @change="setSkill(item.id)">
                            <option :value="0">Select Grade</option>
                              <option
                                v-for="(item, index) in grades"
                                :key="index"
                                :value="item.id"
                              >
                                {{ item.name }}
                              </option>
                        </select>
                  </div>
                </div>
                <span v-if="complete"> Thank you for your answer, Kindly click on 'Done' to submit your application </span>
              </div>
            </div>
          </div>
          <div class="submit-section" v-if="model.length == applicationSkills.length">
            <button class="btn btn-primary submit-btn" type="submit">
              Done
            </button>
          </div>
        </form>
      </div>
    </div>
  </v-dialog>
  <!-- /Experience Modal -->
</template>
<script>
import { required, sameAs } from "vuelidate/lib/validators";
import { applicantService } from "@/services/applicantService";
import Datepicker from "vuejs-datepicker";
export default {
  props: {
    model: {},
    grades: {},
    id: 0,
    skillId: 0,
    dialog: Boolean,
    method: { type: Function },
  },

  components: {
    Datepicker,
  },

  data() {
    return {
      modalDialog: this.dialog,
      applicationId: this.id,
      applicationSkills: [],
      item: {},
      gradeId: 0,
      viewSkill: this.skillId ? this.skillId : 0,
      complete: false,
      error: "",
      message: "",
      submitted: false,
    };
  },

  mounted() {
      if(this.model.length > 0){
          this.item = this.model[this.viewSkill]
      }
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left",
        },
      });
    }
    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  methods: {
    setSkill(id) {
        if(this.gradeId > 0){
       var skill = { 
           applicationId: this.id,
           jobSkillLevelId: id,
           gradeId: this.gradeId
       }

       this.applicationSkills.push(skill);
       if(this.applicationSkills.length < this.model.length){
           this.gradeId = 0
        this.viewSkill = this.viewSkill + 1;
        this.item = this.model[this.viewSkill]
        console.log(this.viewSkill)
       }else{
           this.complete = true;
       }
        }
    },
    postApplicationSkill() {
        applicantService
          .addApplicationSkills(this.applicationSkills
          )
          .then(
            (model) => {
              this.method(true);
              },
            (error) => {
              this.error = error;
            }
          );
      
    },

  },
};
</script>


// WEBPACK FOOTER //
// src/components/career/SkillModal.vue